import { useCallback, useState } from 'react';
import { SchoolsResponse, ESnackbarStyle } from 'shared/types';
import { getSchools } from 'services/api/dashboardService';
import { openNotification } from 'utils/notification-utils';

interface UseDashboardSchoolsResult {
  schoolsData: SchoolsResponse | null;
  isLoading: boolean;
  error: string | null;
  fetchSchools: () => Promise<void>;
}

const useDashboardSchools = (): UseDashboardSchoolsResult => {
  const [schoolsData, setSchoolsData] = useState<SchoolsResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSchools = useCallback(async (): Promise<void> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getSchools();
      setSchoolsData(response.data);
    } catch (e: any) {
      const errorMessage = e.message || 'Failed to fetch schools data';
      setError(errorMessage);
      openNotification(ESnackbarStyle.ERROR, errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    schoolsData,
    isLoading,
    error,
    fetchSchools
  };
};

export default useDashboardSchools;
